import React, { useState, useEffect } from 'react';
import Header from '../Header';
import Footer from '../Footer';
import '../../styles/CommonStyles.css';
import publicService from '../../services/publicService';
import { PUBLIC_URLS } from '../config/apiConfig';
import axios from 'axios';

function ContactPage() {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    subject: '',
    message: ''
  });
  
  const [formSubmitted, setFormSubmitted] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [error, setError] = useState(null);
  const [socialMedia, setSocialMedia] = useState({
    facebook: '',
    linkedin: '',
    youtube: '',
    twitter: ''
  });

  useEffect(() => {
    // Fetch settings (including social media links)
    axios.get(PUBLIC_URLS.SETTINGS)
      .then(response => {
        if (response.data && response.data.socialMedia) {
          setSocialMedia(response.data.socialMedia);
        }
      })
      .catch(error => {
        console.error('Failed to fetch settings:', error);
        // Keep default empty values
      });
  }, []);
  
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prevState => ({
      ...prevState,
      [name]: value
    }));
  };
  
  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    setError(null);
    
    try {
      await publicService.submitContactForm(formData);
      
      // Reset form after successful submission
      setFormData({
        name: '',
        email: '',
        phone: '',
        subject: '',
        message: ''
      });
      
      setFormSubmitted(true);
      
      // Reset submission status after 5 seconds
      setTimeout(() => {
        setFormSubmitted(false);
      }, 5000);
    } catch (error) {
      console.error('Error submitting form:', error);
      setError(
        error.response?.data?.message || 
        'Failed to send message. Please try again later.'
      );
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div className="page-container">
      <Header />
      
      <div className="page-header">
        <h1>CONTACT US</h1>
        <p>Get in touch with Bangalore Valuers' Association</p>
      </div>
      
      <section className="content-section">
        <div className="contact-container" style={{ 
          display: 'flex', 
          flexWrap: 'wrap', 
          gap: '2rem',
          marginBottom: '3rem'
        }}>
          <div className="contact-info" style={{ flex: '1', minWidth: '300px' }}>
            <h2>OUR CONTACT INFORMATION</h2>
            <p>
              We'd love to hear from you! Whether you have a question about membership, 
              our programs, or any other inquiry, our team is ready to assist you.
            </p>
            
            <div className="contact-details" style={{ marginTop: '2rem' }}>
              <div className="contact-item" style={{ marginBottom: '1.5rem' }}>
                <h3 style={{ fontSize: '1.2rem', marginBottom: '0.5rem', color: 'var(--primary-color)' }}>
                  Office Address
                </h3>
                <p style={{ lineHeight: '1.6' }}>
                  522/C, 1st D Cross, 16th Main, 3rd Stage, 4th Block,<br />
                  Basaveshwaranagar, Bangalore - 560 079<br />
                  Karnataka State, INDIA
                </p>
              </div>
              
              <div className="contact-item" style={{ marginBottom: '1.5rem' }}>
                <h3 style={{ fontSize: '1.2rem', marginBottom: '0.5rem', color: 'var(--primary-color)' }}>
                  Email
                </h3>
                <p>
                  <strong>General Inquiries:</strong> <a href="mailto:info@bangalorevaluers.org">info@bangalorevaluers.org</a><br />
                  <strong>Membership Queries:</strong> <a href="mailto:membership@bangalorevaluers.org">membership@bangalorevaluers.org</a>
                </p>
              </div>
              
              <div className="contact-item" style={{ marginBottom: '1.5rem' }}>
                <h3 style={{ fontSize: '1.2rem', marginBottom: '0.5rem', color: 'var(--primary-color)' }}>
                  Phone
                </h3>
                <p>
                  <strong>General Queries:</strong> <a href="tel:+918088383543">+91 8088383543</a><br />
                  <strong>Membership Queries:</strong> <a href="tel:+919071090907">+91 9071090907</a><br />
                </p>
              </div>
              
              <div className="contact-item">
                <h3 style={{ fontSize: '1.2rem', marginBottom: '0.5rem', color: 'var(--primary-color)' }}>
                  Office Hours
                </h3>
                <p>
                  Monday to Friday: 10.00 AM to 5:00 PM<br />
                  Saturday: 10:00 AM to 1:00 PM<br />
                  Sunday: Closed
                </p>
              </div>

              <div className="contact-item" style={{ marginTop: '2rem' }}>
                <h3 style={{ fontSize: '1.2rem', marginBottom: '1rem', color: 'var(--primary-color)' }}>
                  Follow Us
                </h3>
                <div style={{ 
                  display: 'flex', 
                  gap: '1rem', 
                  flexWrap: 'wrap',
                  alignItems: 'center'
                }}>
                  {socialMedia.facebook && (
                    <a 
                      href={socialMedia.facebook} 
                      target="_blank" 
                      rel="noopener noreferrer"
                      title="Facebook"
                      style={{
                        display: 'inline-flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        width: '40px',
                        height: '40px',
                        borderRadius: '50%',
                        backgroundColor: '#3b5998',
                        color: 'white',
                        textDecoration: 'none',
                        transition: 'transform 0.2s, box-shadow 0.2s'
                      }}
                      onMouseEnter={(e) => {
                        e.target.style.transform = 'translateY(-2px)';
                        e.target.style.boxShadow = '0 4px 12px rgba(59, 89, 152, 0.4)';
                      }}
                      onMouseLeave={(e) => {
                        e.target.style.transform = 'translateY(0)';
                        e.target.style.boxShadow = 'none';
                      }}
                    >
                      <i className="fab fa-facebook-f" style={{ fontSize: '18px' }}></i>
                    </a>
                  )}
                  {socialMedia.linkedin && (
                    <a 
                      href={socialMedia.linkedin} 
                      target="_blank" 
                      rel="noopener noreferrer"
                      title="LinkedIn"
                      style={{
                        display: 'inline-flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        width: '40px',
                        height: '40px',
                        borderRadius: '50%',
                        backgroundColor: '#0077b5',
                        color: 'white',
                        textDecoration: 'none',
                        transition: 'transform 0.2s, box-shadow 0.2s'
                      }}
                      onMouseEnter={(e) => {
                        e.target.style.transform = 'translateY(-2px)';
                        e.target.style.boxShadow = '0 4px 12px rgba(0, 119, 181, 0.4)';
                      }}
                      onMouseLeave={(e) => {
                        e.target.style.transform = 'translateY(0)';
                        e.target.style.boxShadow = 'none';
                      }}
                    >
                      <i className="fab fa-linkedin-in" style={{ fontSize: '18px' }}></i>
                    </a>
                  )}
                  {socialMedia.youtube && (
                    <a 
                      href={socialMedia.youtube} 
                      target="_blank" 
                      rel="noopener noreferrer"
                      title="YouTube"
                      style={{
                        display: 'inline-flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        width: '40px',
                        height: '40px',
                        borderRadius: '50%',
                        backgroundColor: '#ff0000',
                        color: 'white',
                        textDecoration: 'none',
                        transition: 'transform 0.2s, box-shadow 0.2s'
                      }}
                      onMouseEnter={(e) => {
                        e.target.style.transform = 'translateY(-2px)';
                        e.target.style.boxShadow = '0 4px 12px rgba(255, 0, 0, 0.4)';
                      }}
                      onMouseLeave={(e) => {
                        e.target.style.transform = 'translateY(0)';
                        e.target.style.boxShadow = 'none';
                      }}
                    >
                      <i className="fab fa-youtube" style={{ fontSize: '18px' }}></i>
                    </a>
                  )}
                  {socialMedia.twitter && (
                    <a 
                      href={socialMedia.twitter} 
                      target="_blank" 
                      rel="noopener noreferrer"
                      title="Twitter"
                      style={{
                        display: 'inline-flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        width: '40px',
                        height: '40px',
                        borderRadius: '50%',
                        backgroundColor: '#1da1f2',
                        color: 'white',
                        textDecoration: 'none',
                        transition: 'transform 0.2s, box-shadow 0.2s'
                      }}
                      onMouseEnter={(e) => {
                        e.target.style.transform = 'translateY(-2px)';
                        e.target.style.boxShadow = '0 4px 12px rgba(29, 161, 242, 0.4)';
                      }}
                      onMouseLeave={(e) => {
                        e.target.style.transform = 'translateY(0)';
                        e.target.style.boxShadow = 'none';
                      }}
                    >
                      <i className="fab fa-twitter" style={{ fontSize: '18px' }}></i>
                    </a>
                  )}
                </div>
              </div>
            </div>
          </div>
          
          <div className="contact-form" style={{ flex: '1', minWidth: '300px' }}>
            <h2>SEND US A MESSAGE</h2>
            <p style={{ marginBottom: '1.5rem' }}>
              Fill out the form below and we'll get back to you as soon as possible.
            </p>
            
            {formSubmitted && (
              <div style={{ 
                backgroundColor: '#d4edda', 
                color: '#155724', 
                padding: '1rem', 
                borderRadius: '4px',
                marginBottom: '1.5rem'
              }}>
                Thank you for your message! We'll get back to you soon.
              </div>
            )}
            
            {error && (
              <div style={{ 
                backgroundColor: '#f8d7da', 
                color: '#721c24', 
                padding: '1rem', 
                borderRadius: '4px',
                marginBottom: '1.5rem'
              }}>
                {error}
              </div>
            )}
            
            <form onSubmit={handleSubmit}>
              <div style={{ marginBottom: '1rem' }}>
                <label 
                  htmlFor="name" 
                  style={{ 
                    display: 'block', 
                    marginBottom: '0.5rem', 
                    fontWeight: '600' 
                  }}
                >
                  Name *
                </label>
                <input 
                  type="text" 
                  id="name" 
                  name="name" 
                  value={formData.name}
                  onChange={handleChange}
                  required
                  style={{ 
                    width: '100%', 
                    padding: '0.8rem', 
                    borderRadius: '4px', 
                    border: '1px solid #ddd',
                    fontSize: '1rem'
                  }}
                />
              </div>
              
              <div style={{ marginBottom: '1rem' }}>
                <label 
                  htmlFor="email" 
                  style={{ 
                    display: 'block', 
                    marginBottom: '0.5rem', 
                    fontWeight: '600' 
                  }}
                >
                  Email *
                </label>
                <input 
                  type="email" 
                  id="email" 
                  name="email" 
                  value={formData.email}
                  onChange={handleChange}
                  required
                  style={{ 
                    width: '100%', 
                    padding: '0.8rem', 
                    borderRadius: '4px', 
                    border: '1px solid #ddd',
                    fontSize: '1rem'
                  }}
                />
              </div>
              
              <div style={{ marginBottom: '1rem' }}>
                <label 
                  htmlFor="phone" 
                  style={{ 
                    display: 'block', 
                    marginBottom: '0.5rem', 
                    fontWeight: '600' 
                  }}
                >
                  Phone
                </label>
                <input 
                  type="tel" 
                  id="phone" 
                  name="phone" 
                  value={formData.phone}
                  onChange={handleChange}
                  style={{ 
                    width: '100%', 
                    padding: '0.8rem', 
                    borderRadius: '4px', 
                    border: '1px solid #ddd',
                    fontSize: '1rem'
                  }}
                />
              </div>
              
              <div style={{ marginBottom: '1rem' }}>
                <label 
                  htmlFor="subject" 
                  style={{ 
                    display: 'block', 
                    marginBottom: '0.5rem', 
                    fontWeight: '600' 
                  }}
                >
                  Subject *
                </label>
                <input 
                  type="text" 
                  id="subject" 
                  name="subject" 
                  value={formData.subject}
                  onChange={handleChange}
                  required
                  style={{ 
                    width: '100%', 
                    padding: '0.8rem', 
                    borderRadius: '4px', 
                    border: '1px solid #ddd',
                    fontSize: '1rem'
                  }}
                />
              </div>
              
              <div style={{ marginBottom: '1.5rem' }}>
                <label 
                  htmlFor="message" 
                  style={{ 
                    display: 'block', 
                    marginBottom: '0.5rem', 
                    fontWeight: '600' 
                  }}
                >
                  Message *
                </label>
                <textarea 
                  id="message" 
                  name="message" 
                  rows="5" 
                  value={formData.message}
                  onChange={handleChange}
                  required
                  style={{ 
                    width: '100%', 
                    padding: '0.8rem', 
                    borderRadius: '4px', 
                    border: '1px solid #ddd',
                    fontSize: '1rem',
                    resize: 'vertical'
                  }}
                ></textarea>
              </div>
              
              <button 
                type="submit" 
                className="btn btn-primary"
                style={{ 
                  backgroundColor: 'var(--primary-color)', 
                  color: 'white',
                  padding: '0.8rem 1.5rem',
                  fontSize: '1rem'
                }}
                disabled={isSubmitting}
              >
                {isSubmitting ? 'SENDING...' : 'SEND MESSAGE'}
              </button>
            </form>
          </div>
        </div>
      </section>
      
      <Footer />
    </div>
  );
}

export default ContactPage;